import React, { useEffect, useState } from 'react';
import { ChevronDown, Github, Linkedin, FileDown, Code2, Database, Palette } from 'lucide-react';

const Hero = () => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const fullText = "Hi, I'm Zaid H. Saigal";

  useEffect(() => {
    if (currentIndex < fullText.length) {
      const timeout = setTimeout(() => {
        setDisplayText(prev => prev + fullText[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex]);

  const scrollToAbout = () => {
    document.querySelector('#about').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-black">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-repeat" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Ccircle cx='7' cy='7' r='7'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }}></div>
        </div>
      </div>

      {/* Floating Icons */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-20 left-10 text-cyan-400/20 animate-float-slow">
          <Code2 size={40} />
        </div>
        <div className="absolute top-40 right-20 text-purple-400/20 animate-float-medium">
          <Database size={35} />
        </div>
        <div className="absolute bottom-40 left-20 text-pink-400/20 animate-float-fast">
          <Palette size={30} />
        </div>
      </div>

      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Main Heading with Typewriter Effect */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
            <span className="bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">
              {displayText}
            </span>
            <span className="animate-pulse">|</span>
          </h1>

          {/* Subtitle */}
          <div className="text-xl md:text-2xl text-gray-300 mb-8 space-y-2">
            <p className="font-light">A passionate <span className="text-cyan-400 font-semibold">MERN Stack Developer</span></p>
            <p className="text-lg text-gray-400">Building scalable web apps, interactive UIs, and modern solutions</p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button 
              onClick={scrollToAbout}
              className="group bg-gradient-to-r from-cyan-500 to-purple-600 hover:from-cyan-600 hover:to-purple-700 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/25"
            >
              Explore My Work
              <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300">→</span>
            </button>
            
            <a
              href="#contact"
              className="border-2 border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-gray-900 px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
            >
              Get In Touch
            </a>
          </div>

          {/* Social Links */}
          <div className="flex items-center justify-center space-x-6 mb-12">
            <a
              href="https://github.com/zaidharissheikh"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center space-x-2 text-gray-300 hover:text-cyan-400 transition-all duration-300"
            >
              <div className="p-3 rounded-full border border-gray-600 group-hover:border-cyan-400 group-hover:shadow-lg group-hover:shadow-cyan-400/25 transition-all duration-300">
                <Github size={24} />
              </div>
              <span className="hidden sm:block">GitHub</span>
            </a>
            
            <a
              href="https://www.linkedin.com/in/zaid-haris-saigal-680967248/"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center space-x-2 text-gray-300 hover:text-cyan-400 transition-all duration-300"
            >
              <div className="p-3 rounded-full border border-gray-600 group-hover:border-cyan-400 group-hover:shadow-lg group-hover:shadow-cyan-400/25 transition-all duration-300">
                <Linkedin size={24} />
              </div>
              <span className="hidden sm:block">LinkedIn</span>
            </a>
            
            <button className="group flex items-center space-x-2 text-gray-300 hover:text-cyan-400 transition-all duration-300">
              <div className="p-3 rounded-full border border-gray-600 group-hover:border-cyan-400 group-hover:shadow-lg group-hover:shadow-cyan-400/25 transition-all duration-300">
                <FileDown size={24} />
              </div>
              <span className="hidden sm:block">Resume</span>
            </button>
          </div>

          {/* Scroll Indicator */}
          <button 
            onClick={scrollToAbout}
            className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-gray-400 hover:text-cyan-400 transition-colors duration-300 animate-bounce"
          >
            <ChevronDown size={32} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
